import 'bootstrap/dist/js/bootstrap.min.js';
import { createPopper } from '@popperjs/core';
// Swiper
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import Cookie from 'js-cookie';

document.addEventListener('DOMContentLoaded', function () {
  // init when .swiper exists
  if (document.querySelector('.swiper')) {
    const swiper = new Swiper('.swiper', {
      loop: true,
      loopAdditionalSlides: 1,
      //effect: 'fade',
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      speed: 1000,
      slidesPerView: 'auto',
      centeredSlides: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
    });

    document.querySelector('.stopbtn').addEventListener('click', (ev) => {
      console.log(ev.target);
      const _class = ev.target.classList;
      if (_class.contains('stop')) {
        _class.remove('stop');
        _class.add('start');
        swiper.autoplay.stop();
      } else {
        _class.remove('start');
        _class.add('stop');
        swiper.autoplay.start();
      }
    });
  }

  // SPで hover クラスを付与
  document.querySelectorAll('.js_h').forEach((jsh) => {
    ['mouseenter', 'touchstart', { passive: true }].forEach((event) => {
      jsh.addEventListener(event, () => {
        jsh.classList.add('hover');
      });
    });
    ['mouseleave', 'touchend', { passive: true }].forEach((event) => {
      jsh.addEventListener(event, () => {
        jsh.classList.remove('hover');
      });
    });
  });

  // header 高さ分アンカーリンクをずらす
  document.querySelectorAll('.editable-area a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', function (event) {
      event.preventDefault();

      const target = document.querySelector(this.getAttribute('href'));
      const headerHeight = document.querySelector('.header-container').offsetHeight;

      window.scrollTo({
        //       top: target.offsetTop - headerHeight,
        top: target.offsetTop,
        behavior: 'smooth',
      });
    });
  });

  // ハンバーガーメニューボタンがクリックされたときのイベントハンドラを設定
  document.querySelector('.navbar-toggler').addEventListener('click', function () {
    // body要素を取得
    var body = document.body;

    // 現在のbodyのスタイルを取得
    var bodyStyle = window.getComputedStyle(body);

    // bodyのoverflowスタイルがhiddenかどうかを確認
    if (bodyStyle.overflow === 'hidden') {
      // もしoverflowがhiddenなら、bodyのスタイルを元に戻す
      body.style.height = '';
      body.style.overflow = '';
    } else {
      // そうでなければ、bodyにheight: 100%とoverflow: hiddenを設定し、スクロールを無効にする
      body.style.height = '100%';
      body.style.overflow = 'hidden';
    }
  });

  // Cookie Consent
  const THE_COOKIE = '_privacy_consent';
  const consentPanel = document.getElementById('enableCookies');
  const consent = Cookie.get(THE_COOKIE);
  const COOKIE_LIFETIME = 7 * 4 * 3; // 7 days * 4 weeks * 3 months

  if (undefined === consent) {
    consentPanel.style.display = 'block';
  } else {
    consentPanel.style.display = 'none';
  }

  if (consentPanel.style.display === 'block') {
    document.getElementById('consent-agreed').addEventListener('click', function () {
      console.log('agreed');
      Cookie.set(THE_COOKIE, 'true', { expires: COOKIE_LIFETIME });
      consentPanel.style.display = 'none';
      location.reload();
    });

    // document.getElementById('consent-disagreed').addEventListener('click', function () {
    //   console.log('disagreed');
    //   Cookie.set(THE_COOKIE, 'false', {expires: COOKIE_LIFETIME});
    //   consentPanel.style.display = "none";
    // });
  }

  const btnCookieReactivate = document.querySelector(
    '.btn-call-cookie-accept > a.wp-block-button__link'
  );
  if (btnCookieReactivate !== null) {
    btnCookieReactivate.addEventListener('click', function (ev) {
      console.log('reactivate cookie');
      Cookie.set(THE_COOKIE, 'true', { expires: COOKIE_LIFETIME });
      consentPanel.style.display = 'none';
      location.reload();
    });
  }

  // if cookie "_privacy_consent" is not set or false, delete all element with class "wp-block-embed__wrapper"
  if (undefined === consent || false === consent) {
    document.querySelectorAll('.wp-block-embed__wrapper > iframe').forEach((el) => {
      // 1: protocol, 2: subdomain, 3: domain, 4: path, 5: video code, 6: query string
      let parsed = el.src.match(
        /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube(-nocookie)?\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|live\/|v\/)?)([\w\-]+)(\S+)?$/
      );
      if (parsed !== null && parsed[6] !== undefined) {
        let id = parsed[6];
        el.parentNode.innerHTML =
          `<img src="https://img.youtube.com/vi/${id}/maxresdefault.jpg" alt="動画サムネール">` +
          '<div class="no-yt-player-for-no-cookie"><p>Cookieが無効なため、動画プレーヤーの埋め込みを停止しております。<br>以下のURLからご視聴ください。<br>' +
          `<a href="https://www.youtube.com/watch?v=${id}" target="_blank" rel="noopener noreferrer" class="youtube-link">https://www.youtube.com/watch?v=${id}</a>` +
          '</p></div>';
        el.remove();
      }
    });
  }

  // if cookie "_privacy_consent" is not set or false, delete all iframe with id "swap-google-map"
  if (undefined === consent || false === consent) {
    // Find all element with class = swap-google-map
    document.querySelectorAll('.swap-google-map').forEach((el) => {
      // Get data-url attributes for url
      let url = el.getAttribute('data-url');
      let lang = window.location.pathname.split('/')[1];
      if (lang === 'en') {
        el.innerHTML =
          `<p class='map-alart-msg'>Google Map is disabled due to cookie is disabled.` +
          '<br>Please view the map from the following URL.' +
          `<br><a href='${url}' target='_blank' rel='noopener noreferrer'>${url}</a></p>`;
      } else {
        // Create new div element with innerHTML a tag href to url
        el.innerHTML =
          `<p class='map-alart-msg'>Cookieが無効なため、Googleマップの埋め込みを停止しております。` +
          '<br>以下のURLからご覧ください。' +
          `<br><a href='${url}' target='_blank' rel='noopener noreferrer'>${url}</a></p>`;
      }
    });
  }
});
